(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quiz-launcher"] && !Shopify.designMode) return;
  try {
    (function(){
  function openQuiz(e){
    var link=e.target.closest('[data-vechen-quiz-launcher]');
    if(!link)return;
    var root=document.querySelector('[data-fyf]');
    if(root && root.fyf && typeof root.fyf.open==='function'){
      e.preventDefault();
      root.fyf.open();
      return;
    }
    var trigger=document.querySelector('[data-fyf-start]');
    if(trigger){
      e.preventDefault();
      trigger.click();
      return;
    }
    window.location.href=link.href+(link.href.indexOf('?')===-1?'?':'&')+'open=1';
  }
  document.addEventListener('click',openQuiz);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vechen-editorial"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vechen-recipe-popup')) customElements.define('vechen-recipe-popup', class extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-recipe-details] > summary');
    this.imageTrigger = this.querySelector('[data-recipe-image]');
    this.imageTrigger?.addEventListener('click', this.onImageOpen);
    if (!this.trigger) return;
    this.trigger.setAttribute('aria-haspopup', 'dialog');
    this.trigger.addEventListener('click', this.onOpen);
  }
  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onOpen);
    this.imageTrigger?.removeEventListener('click', this.onImageOpen);
    this.dialog?.close();
    this.dialog?.remove();
  }
  onOpen = (event) => { event.preventDefault(); this.openRecipe(); };
  onImageOpen = () => { this.openRecipe(this.imageTrigger); };
  openRecipe(focusTarget = this.trigger) {
    if (this.dialog?.open) return;
    const dialog = document.createElement('dialog');
    dialog.className = 've-recipe-modal';
    const title = this.querySelector('[data-recipe-title]');
    dialog.setAttribute('aria-label', title?.textContent.trim() || 'Recipe');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 've-recipe-modal__close';
    close.setAttribute('aria-label', this.dataset.closeLabel);
    close.textContent = '×';
    const inner = document.createElement('div');
    inner.className = 've-recipe-modal__inner';
    const media = document.createElement('div');
    media.className = 've-recipe-modal__media';
    const image = this.querySelector('img');
    if (image) {
      const copy = image.cloneNode(true);
      copy.loading = 'eager';
      copy.sizes = '(min-width:750px) 440px, 100vw';
      const slide = document.createElement('div');
      slide.className = 've-recipe-modal__slide';
      slide.append(copy);
      media.append(slide);
    }
    const extraMedia = this.querySelector('[data-recipe-media]');
    if (extraMedia) media.append(extraMedia.content.cloneNode(true));
    const slides = Array.from(media.querySelectorAll('.ve-recipe-modal__slide'));
    if (slides.length > 1) {
      const nav = document.createElement('div');
      nav.className = 've-recipe-modal__gallery-nav';
      const previous = document.createElement('button');
      previous.type = 'button';
      previous.setAttribute('aria-label', 'Previous recipe image or video');
      previous.textContent = '‹';
      const count = document.createElement('span');
      count.setAttribute('aria-live', 'polite');
      const next = document.createElement('button');
      next.type = 'button';
      next.setAttribute('aria-label', 'Next recipe image or video');
      next.textContent = '›';
      let selected = 0;
      const show = (index) => {
        selected = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== selected;
          if (slide.hidden) slide.querySelector('video')?.pause();
        });
        count.textContent = `${selected + 1} / ${slides.length}`;
      };
      previous.addEventListener('click', () => show(selected - 1));
      next.addEventListener('click', () => show(selected + 1));
      nav.append(previous, count, next);
      media.append(nav);
      show(0);
    }
    const body = document.createElement('div');
    body.className = 've-recipe-modal__body';
    const heading = document.createElement('h2');
    heading.textContent = title?.textContent.trim();
    body.append(heading);
    for (const selector of ['[data-recipe-details] .ve-prose', '.ve-recipe-card__actions']) {
      const content = this.querySelector(selector);
      if (content) body.append(content.cloneNode(true));
    }
    inner.append(media, body);
    dialog.append(close, inner);
    document.body.append(dialog);
    this.dialog = dialog;
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      dialog.remove();
      this.dialog = null;
      if (this.isConnected) focusTarget?.focus({ preventScroll: true });
    }, { once: true });
    dialog.showModal();
    close.focus({ preventScroll: true });
  }
});

if(!customElements.get('vechen-recipes'))customElements.define('vechen-recipes',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.limit=6;this.cards=[...this.querySelectorAll('[data-recipe-card]')];this.search=this.querySelector('[data-recipe-search]');this.product=this.querySelector('[data-recipe-product]');this.more=this.querySelector('[data-recipe-more]');this.status=this.querySelector('[data-recipe-status]');this.empty=this.querySelector('[data-recipe-empty]');const products=new Map(this.cards.map(c=>[c.dataset.product,c.dataset.productTitle]));products.forEach((title,handle)=>{const option=document.createElement('option');option.value=handle;option.textContent=title;this.product.append(option)});this.querySelector('[data-recipe-controls]').hidden=false;this.status.hidden=false;this.search.addEventListener('input',()=>{this.limit=6;this.update()});this.product.addEventListener('change',()=>{this.limit=6;this.update()});this.more.addEventListener('click',()=>{const previouslyVisible=this.cards.filter(c=>!c.hidden).length;this.limit+=6;this.update();this.cards.filter(c=>!c.hidden)[previouslyVisible]?.focus({preventScroll:true})});this.onHash=()=>this.openShared();window.addEventListener('hashchange',this.onHash);this.update();this.openShared()}
 disconnectedCallback(){window.removeEventListener('hashchange',this.onHash);this.ready=false}
 update(){const q=this.search.value.trim().toLocaleLowerCase(),product=this.product.value;const matches=this.cards.filter(c=>(!product||c.dataset.product===product)&&c.dataset.search.toLocaleLowerCase().includes(q));this.cards.forEach(c=>{c.hidden=true});matches.slice(0,this.limit).forEach(c=>{c.hidden=false});this.more.hidden=matches.length<=this.limit;this.empty.hidden=matches.length>0;this.status.textContent=this.status.dataset.count.replace('[count]',matches.length)}
 openShared(){let id;try{id=decodeURIComponent(location.hash.slice(1))}catch{return}const card=this.cards.find(c=>c.id===id);if(!card)return;this.search.value='';this.product.value='';this.limit=Math.max(6,this.cards.indexOf(card)+1);this.update();customElements.whenDefined('vechen-recipe-popup').then(()=>card.openRecipe())}
});
function initVechenVideos(scope=document){scope.querySelectorAll('[data-ve-video]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const video=root.querySelector('video'),button=root.querySelector('[data-ve-video-toggle]');if(!video||!button)return;const reduced=matchMedia('(prefers-reduced-motion: reduce)');const saveData=navigator.connection?.saveData;let userPaused=false;video.controls=false;button.hidden=false;const update=()=>{button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-label',button.textContent)};video.addEventListener('play',update);video.addEventListener('pause',update);button.addEventListener('click',()=>{if(video.paused){userPaused=false;video.play().catch(()=>{})}else{userPaused=true;video.pause()}});if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting&&!userPaused&&!reduced.matches&&!saveData)video.play().catch(()=>{});else video.pause()}),{threshold:.3});observer.observe(video);root.veObserver=observer}reduced.addEventListener('change',()=>{if(reduced.matches)video.pause()});document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause()});update()})}
function labelVechenExternalLinks(scope=document){scope.querySelectorAll('.rte a[href],.ingredient-description a[href],.ve-prose a[href]').forEach(link=>{if(link.dataset.veExternalLabelled)return;let destination;try{destination=new URL(link.href,location.href)}catch{return}if(!/^https?:$/.test(destination.protocol)||destination.hostname.replace(/^www\./,'')===location.hostname.replace(/^www\./,''))return;link.dataset.veExternalLabelled='true';const walker=document.createTreeWalker(link,NodeFilter.SHOW_TEXT);let last;while(walker.nextNode())last=walker.currentNode;if(last)last.textContent=last.textContent.replace(/\s*[↗🔗]\uFE0F?\s*$/u,'').trimEnd();link.querySelectorAll('span').forEach(span=>{if(/^[\s↗🔗\uFE0F]+$/u.test(span.textContent))span.remove()});if(/opens external (site|link)/i.test(link.textContent))return;const note=document.createElement('span');note.className='ve-external-note';note.textContent=' (opens external site)';link.append(note)})}
window.vechenLabelExternalLinks=labelVechenExternalLinks;
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{initVechenVideos();labelVechenExternalLinks()});else{initVechenVideos();labelVechenExternalLinks()}document.addEventListener('shopify:section:load',e=>{initVechenVideos(e.target);labelVechenExternalLinks(e.target)});document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-ve-video]').forEach(r=>r.veObserver?.disconnect()));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vechen-share"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vechen-share')){
    customElements.define('vechen-share',class extends HTMLElement{
      connectedCallback(){
        if(this.ready)return;
        this.ready=true;
        this.button=this.querySelector('button');
        this.status=this.querySelector('[role="status"]');
        if(!navigator.share)this.querySelector('[data-share-label]').textContent=this.dataset.copy;
        this.button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();this.share()});
      }
      publicURL(){
        const base=document.querySelector('link[rel="canonical"]')?.href||location.href;
        const url=new URL(this.dataset.url,base);
        url.search='';
        return url.href;
      }
      async share(){
        if(this.button.disabled)return;
        this.button.disabled=true;
        this.status.textContent='';
        try{
          const data={title:this.dataset.title,url:this.publicURL()};
          if(navigator.share&&(!navigator.canShare||navigator.canShare(data))){
            try{await navigator.share(data)}catch(error){if(error.name!=='AbortError')this.showCopy(data.url)}
          }else{await this.copy(data.url)}
        }finally{this.button.disabled=false}
      }
      async copy(url){
        try{
          if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url);
          this.status.textContent=this.dataset.copied;
          this.querySelector('.vechen-share__fallback')?.remove();
          clearTimeout(this.resetTimer);
          this.resetTimer=setTimeout(()=>{this.status.textContent=''},4000);
        }catch{this.showCopy(url)}
      }
      showCopy(url){
        let fallback=this.querySelector('.vechen-share__fallback');
        if(!fallback){
          fallback=document.createElement('div');fallback.className='vechen-share__fallback';
          const input=document.createElement('input');input.type='text';input.readOnly=true;input.value=url;input.setAttribute('aria-label',this.dataset.copy);
          const button=document.createElement('button');button.type='button';button.className='vechen-share__button';button.textContent=this.dataset.copy;
          button.addEventListener('click',event=>{event.stopPropagation();this.copy(url)});
          fallback.append(input,button);this.append(fallback);
        }
        this.status.textContent=this.dataset.manual;
        const input=fallback.querySelector('input');input.focus({preventScroll:true});input.select();
      }
      disconnectedCallback(){clearTimeout(this.resetTimer)}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
